import { FormHandler } from '~/shared/utils/form-handler';
import { ScreenTransitions } from '~/shared/utils/screen-transitions';

export class AuthScreen {
  constructor(screen, formHandlerOptions = {}) {
    this.screen = screen;
    this.screenContext = screen?.parentElement;
    this.form = screen?.querySelector('form[data-auth-form]');

    if (!this.screen) {
      throw new Error('Screen not found');
    }

    if (this.form) {
      this.formHandler = new FormHandler(this.form, {
        onSuccess: this.handleSuccessResponse.bind(this),
        ...formHandlerOptions,
      });
    }
  }

  async handleSuccessResponse(response) {
    // Redirect to a new URL if the response is a 202
    if (response.status === 202) {
      const { redirect_to: redirectTo } = await response.json();
      if (!redirectTo) return;

      window.location.href = redirectTo;
    } else {
      // Else inject the new screen HTML
      const nextScreenHtml = await response.text();
      this.injectAndTransitionToScreen(nextScreenHtml);
    }
  }

  injectAndTransitionToScreen(html) {
    if (!html) return;
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newScreens = doc.querySelectorAll('[data-screen]');

    newScreens.forEach((newScreen, index) => {
      const newScreenId = newScreen.getAttribute('data-screen');
      const existingScreen = this.screenContext.querySelector(`[data-screen="${newScreenId}"]`);

      if (existingScreen) {
        existingScreen.replaceWith(newScreen);
      } else {
        this.screenContext.appendChild(newScreen);
      }

      const injectedScreen = this.screenContext.querySelector(`[data-screen="${newScreenId}"]`);
      injectedScreen.dispatchEvent(new Event('auth-screen-injected', { bubbles: true, cancelable: true }));

      // transition to first new screen
      if (index === 0) {
        ScreenTransitions.transitionToScreen({
          targetScreen: injectedScreen,
        });
      }
    });
  }
}
